import { useVideoRecorder } from "./use-video-recorder";
import { VideoRecorderMenu } from "./video-recorder-menu";
import { VideoRecorderPlayer } from "./video-recorder-player";

/** Props Interface */
interface VideoRecorderProps {
	/** Hides the recording controls — for a host that is busy shipping the recording off. */
	withControls?: boolean;
}

/**
 * The preview surface for a recording in hand.
 *
 * The source picker is deliberately not rendered here. Starting a recording needs a
 * destination — a row to upload against and a page to return to — and only the host knows what
 * that is, so the host renders `VideoRecorderStartModal` itself and supplies it.
 */
export function VideoRecorder({ withControls = true }: VideoRecorderProps) {
	/** Store */
	const { hasVideo, isRecording } = useVideoRecorder();

	/** Guard */
	if (!hasVideo && !isRecording) return null;

	/** Render */
	return (
		<div className="v-stack gap-2">
			<VideoRecorderPlayer />
			{withControls && <VideoRecorderMenu />}
		</div>
	);
}
